import { GlobalStyles, Theme } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AdapterDayjs as DatePickersProAdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { LocalizationProvider as DatePickersProLocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs as DatePickersAdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider as DatePickersLocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { LicenseInfo } from "@mui/x-license";
import React from "react";

import * as colors from "./colors";
import DEFAULT_THEME from "./theme";

const MUI_LICENSE_KEY =
  "83d720262a9b53faf649f57609865295Tz0xMTU2ODIsRT0xNzgzOTg3MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";
LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const ROOT_SELECTOR = ":root";
type ThemeProviderProps = {
  children: React.ReactNode;
  theme?: Theme | ((theme: Theme) => Theme);
};

// Generate CSS variables from color palettes for Figma import
const colorCssVars = Object.entries(colors).reduce((acc, [name, palette]) => {
  Object.entries(palette).forEach(([shade, value]) => {
    acc[`--backpack-color-${name}-${shade}`] = value;
  });
  return acc;
}, {} as Record<string, string>);

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
  const themeToUse =
    typeof theme === "function" ? theme(DEFAULT_THEME) : theme || DEFAULT_THEME;

  return (
    <>
      <GlobalStyles styles={{ [ROOT_SELECTOR]: colorCssVars }} />
      <MuiThemeProvider theme={themeToUse}>{children}</MuiThemeProvider>
    </>
  );
};

export default React.memo((props: ThemeProviderProps) => (
  <DatePickersProLocalizationProvider dateAdapter={DatePickersProAdapterDayjs}>
    <DatePickersLocalizationProvider dateAdapter={DatePickersAdapterDayjs}>
      <ThemeProvider {...props} />
    </DatePickersLocalizationProvider>
  </DatePickersProLocalizationProvider>
));
